export default __webpack_public_path__ + "static/media/background.122bbcc8.jpg";